export default __webpack_public_path__ + "static/batch-8faef2c30e3319317593184f7270c676.webp";